import Phaser from "phaser";
import Character from "./Character";
import Enemy from "./Enemy";
import Boulder from "./Boulder";
import { CLASS_NAMES, DIRS } from "../../utils/constants";
import NPCharacter from "./NPCharacter";
import Ground from "./Ground";
import Jewel from "./Jewel";
import * as Controller from "../Controller/Controller";

export default class Player extends Character {
  constructor(id, level) {
    super(id, level);
    this.power = 0.5;
    this.moveIntentDir = "";
    this.connected = true;
    this.torch = null;
    this.mandatoryPath = [];
    this.ligth = null;

    // flag to make Brave to await like Rockford
    this.impersonateRockford = false;

    const scene = level.scene;
    scene.input.keyboard.removeListener("keydown", this.onKeyDown);
    scene.input.keyboard.addListener("keydown", this.onKeyDown.bind(this));

    scene.input.keyboard.removeListener("keyup", this.onKeyUp);
    scene.input.keyboard.addListener("keyup", this.onKeyUp.bind(this));
  }
  disconnect() {
    if (!this.connected) {
      return false;
    }
    this.connected = false;
    this.moveIntentDir = "";
    if (!this.inactive) {
      this.animIdle();
    }
    this.level.scene.events.emit("player:disconnected");
  }
  reconnect() {
    if (this.connected) {
      return false;
    }
    this.connected = true;
    this.level.scene.events.emit("player:reconnected");
  }
  onKeyUp(event) {
    if (Controller.getDirection(this.moveIntentDir) === Controller.getDirection(event.key) && this.connected) {
      this.moveIntentDir = "";
      this.pushingDirection = null;
    }
  }
  onKeyDown(event) {
    if (
      !event.repeat && (
      Controller.isUp(event.key) ||
      Controller.isDown(event.key) ||
      Controller.isLeft(event.key) ||
      Controller.isRight(event.key)
      ) && this.connected
    ) {
      this.moveIntentDir = Controller.getDirection(event.key);
      // calls loop to avoid delay between key press and visual movement at the begining of next loop
      if (!this.isMoving) {
        this.level.playerLoop();
      }
    }
  }
  destroy() {}
  moveToNextPosition() {
    if (!this.mandatoryPath.length) {
      this.moveIntentDir = "";
      this.animIdle();
      return false;
    }
    const nextPos = this.mandatoryPath.shift();
    this.calcMoveIntent(nextPos);
    this.level.moveObject(this, nextPos);
    return true;
  }
  calcMoveIntent(nextPos) {
    this.moveIntentDir =
      this.position.y < nextPos.y ? DIRS.DOWN : this.moveIntentDir;
    this.moveIntentDir =
      this.position.y > nextPos.y ? DIRS.UP : this.moveIntentDir;
    if (this.position.x < nextPos.x) {
      this.moveIntentDir = DIRS.LEFT;
      this.animRunRight();
    }
    if (this.position.x > nextPos.x) {
      this.moveIntentDir = DIRS.RIGHT;
      this.animRunLeft();
    }
  }
  animIdle() {
    const animName = this.hasPickaxe
      ? "brave_idle_pickaxe"
      : this.impersonateRockford
      ? "brave_idle_rockford"
      : "brave_idle";
    if (
      (this.moveIntentDir === "" || !this.canMoveDir(this.moveIntentDir)) &&
      !this.inactive
    ) {
      this.alien?.play(animName);
      this.alien?.setFlipX(false);
      this.alien?.setOrigin(0, 0.25);

      this.torch?.play("torch_idle");
      this.torch?.setFlipX(false);
      this.torch?.setOrigin(0, 0.25);
    }
  }
  animPushRight() {
    this.alien?.play("brave_push");
    this.alien.setFlipX(false);
    this.alien.setOrigin(0, 0.25);

    this.torch?.play("torch_push");
    this.torch?.setFlipX(false);
    this.torch?.setOrigin(0, 0.25);
  }
  animPushLeft() {
    this.alien?.play("brave_push");
    this.alien.setFlipX(true);
    this.alien.setOrigin(0.25, 0.25);

    this.torch?.play("torch_push");
    this.torch?.setFlipX(true);
    this.torch?.setOrigin(0.25, 0.25);
  }
  animRun() {
    let dirVariant = "";
    let pickaxeVariant = "";
    let actionVariant = "_run";
    let character = "brave";
    if (Controller.isUp( this.moveIntentDir)) {
      dirVariant = "_up";
    }
    if (Controller.isDown(this.moveIntentDir)) {
      dirVariant = "_down";
    }
    if (this.isBrakingGround) {
      actionVariant = "_break";
    }
    if (this.hasPickaxe) {
      pickaxeVariant = "_pickaxe";
      if (dirVariant === "" && this.isBrakingGround && Math.random() > 0.5) {
        pickaxeVariant = pickaxeVariant + "_alt";
      }
    }

    const animName = character + actionVariant + pickaxeVariant + dirVariant;

    if (this.alien.anims.currentAnim.key !== animName && !this.inactive) {
      this.alien.play(animName);

      // if(actionVariant.includes('run')) {
      this.torch?.play("torch_run" + dirVariant);
      // }
      // if(actionVariant.includes('break')) {
      //   this.torch?.play('torch_break' + dirVariant)
      // }
    }
  }
  // these 2 method are probably switched.
  // animRunRight is called when player runs left and viceversa
  animRunRight() {
    this.alien.setFlipX(false);
    this.alien.setOrigin(0, 0.25);
    // this.alien.setFlipX(true)
    this.torch?.setFlipX(false);
    this.torch?.setOrigin(0, 0.25);
    // this.torch?.setFlipX(true)
  }
  animRunLeft() {
    this.alien.setFlipX(true);
    this.alien.setOrigin(0.25, 0.25);
    // this.alien.setFlipX(false)
    this.torch?.setFlipX(true);
    this.torch?.setOrigin(0.25, 0.25);
    // this.torch?.setFlipX(false)
  }

  die() {
    this.inactive = true;
    // this.disconnect()
    const scene = this.level.scene;
    scene.input.keyboard.off("keydown");
    scene.input.keyboard.off("keyup");
    // animate die
    this.level.onCharacterDie(this);
    this.alien.play("brave_dies");
    this.alien.on(Phaser.Animations.Events.ANIMATION_COMPLETE, () => {
      this.destroy();
      this.alien.alpha = 0;
    });
  }

  overrunBy(el) {
    if (el.isClass(CLASS_NAMES.FALLABLE)) {
      this.level.scene.events.emit("sounds:death_by_rock_hit");
    }

    if (el.constructor.className !== NPCharacter.className) {
      this.die();
    }
  }
  runningOver(el) {
    if (el.isClass(Enemy)) {
      this.die();
    }

    if (el.isClass(Ground)) {
      const layer = this.level.scene.children.getByName("layer_1");
      const { tilemap: map } = layer;
      this.level.break_effect.x = map.tileToWorldX(el.position.x);
      this.level.break_effect.y = map.tileToWorldY(el.position.y);
      this.level.break_effect.play("ground_breaks");
    }
    if (el.isClass(Jewel)) {
      const layer = this.level.scene.children.getByName("layer_1");
      const { tilemap: map } = layer;
      this.level.pick_effect.x = map.tileToWorldX(el.position.x);
      this.level.pick_effect.y = map.tileToWorldY(el.position.y);
      this.level.pick_effect.play("jewel_pick");
    }
  }

  setupLight() {
    this.light = this.level.scene.lights
      .addLight(this.alien.x, this.alien.y, 1000)
      .setColor(0xe6c8c8)
      .setIntensity(1.5);
  }

  ligthTorch() {
    if (!this.light) {
      this.setupLight();
    }
    this.alien.alpha = 1;
    this.torch = this.level.scene.add.sprite(48, 16).setOrigin(0, 0.25);
    this.torch.setScale(this.alien.scaleX);
    this.torch.depth = 4.5; // .5 higher than player when has follower
    this.torch.play("torch_idle");
    this.level.scene.time.addEvent({
      delay: 10,
      callback: function () {
        if (this.torch) {
          this.torch.x = this.alien?.x;
          this.torch.y = this.alien?.y;
        }
      },
      callbackScope: this,
      repeat: -1,
    });

    this.level.scene.time.addEvent({
      delay: 100,
      callback: function () {
        if (this.light) {
          this.light.x = this.alien.x;
          this.light.y = this.alien.y;
        }
        if (!this.torch && this.light?.intensity > 0) {
          this.light.setIntensity(this.light.intensity - 0.3);
        }

        const isTooCloseToExit =
          this.position.y === this.level.exit.position.y &&
          Math.abs(this.position.x - this.level.exit.position.x) <= 3;
        if (this.torch && this.light?.intensity < 1.5 && !isTooCloseToExit) {
          this.light.setIntensity(this.light.intensity + 0.3);
          Phaser.Geom.Ellipse.Random(this.alien, this.light);
        }
      },
      callbackScope: this,
      repeat: -1,
    });
  }

  setOffTorch() {
    this.torch.destroy();
    this.torch = null;
    this.light.setIntensity(0);
    this.light = null;
  }
}

Player.className = CLASS_NAMES.PLAYER;
